import { ReactNode } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Table,
  CombinedTable,
  TableAvailability,
  TableWeekdayAvailability,
  Reservation,
} from "@/types/table";
import {
  DashboardReservation,
  ReservationStatusInfo,
  SendReservationEmailPayload,
} from "@/types/reservation";
import { ReservationPreviewContent } from "@/components/ReservationPreviewContent";

interface TimelineReservationPopoverProps {
  reservation: DashboardReservation;
  endTime: string;
  tables: Table[];
  combinedTables: CombinedTable[];
  convertedReservations: Reservation[];
  availabilities: TableAvailability[];
  weekdayAvailabilities: TableWeekdayAvailability[];
  getReservationStatus: (reservation: DashboardReservation) => ReservationStatusInfo;
  getLoyaltyBadge: (email: string | undefined) => ReactNode;
  getNoShowBadge: (email: string | undefined) => ReactNode;
  getCustomerNotes: (email: string | undefined) => string | null;
  onUpdateStatus: (
    reservationId: number,
    status: "arrivé" | "annulé" | "planifié",
    cancellationReason?: string,
  ) => void;
  onEdit: (reservation: DashboardReservation) => void;
  onQuickTableChange: (
    reservationId: number,
    tableId: string | null,
    combinedTableId: string | null,
  ) => void;
  onSendEmail: (data: SendReservationEmailPayload) => void;
  sendingEmail: number | null;
  onSwapSelect?: (reservation: DashboardReservation) => void;
  onSwapTables?: (aSupabaseId: string, bSupabaseId: string) => Promise<void> | void;
  reservationSettings?: {
    bookingMode: "slot" | "time";
    reservationDurationMinutes: number;
  };

  children: ReactNode;
}

export const TimelineReservationPopover = ({
  children,
  ...contentProps
}: TimelineReservationPopoverProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent side="top" align="start" className="w-96 max-w-[calc(100vw-1rem)] p-0 z-50" sideOffset={4}>
        <ReservationPreviewContent {...contentProps} />
      </PopoverContent>
    </Popover>
  );
};
